import { useContext, createContext } from "react";
import * as Floating from "./Floating";
const FloatingOverrideContext = createContext(null);
const useFloating = (props) => {
  var _a;
  const context = useContext(FloatingOverrideContext);
  return (_a = context || Floating.useFloating) == null ? void 0 : _a(props);
};
export {
  FloatingOverrideContext,
  useFloating
};
//# sourceMappingURL=useFloating.js.map
